import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createFnbReport,
  deleteFnbReport,
  getFnbReports,
  updateFnbReport,
} from "./yourReports.thunk";

const initialState = {
  yourReports: [],
  loading: true,
  error: null,
  updatingId: null,
};

export const asyncThunkCreateFnbReport = createAsyncThunk(
  "fnb/create report",
  createFnbReport
);

export const asyncThunkUpdateFnbReport = createAsyncThunk(
  "fnb/update report",
  updateFnbReport
);

export const asyncThunkDeleteFnbReport = createAsyncThunk(
  "fnb/delete report",
  deleteFnbReport
);

export const asyncThunkGetAllReports = createAsyncThunk(
  "fnb/fetch reports",
  getFnbReports
);

const yourReportsSlice = createSlice({
  name: "yourReports",
  initialState,
  reducers: {
    addReport: (state, action) => {
      state.yourReports.push(action.payload);
    },
    updateReport: (state, action) => {
      const { index, report } = action.payload;
      state.yourReports[index] = report;
    },
    removeReport: (state, action) => {
      const { reportIndex } = action.payload;
      const newState = state.yourReports.filter((_, i) => i != reportIndex);
      state.yourReports = newState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(asyncThunkGetAllReports.pending, (state) => {
        state.loading = true;
      })
      .addCase(asyncThunkGetAllReports.fulfilled, (state, action) => {
        state.loading = false;
        state.yourReports = action.payload.data;
      })
      .addCase(asyncThunkGetAllReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(asyncThunkCreateFnbReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(asyncThunkCreateFnbReport.fulfilled, (state, action) => {
        state.loading = false;
        state.yourReports.push(action.payload.data[0]);
      })
      .addCase(asyncThunkCreateFnbReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(asyncThunkUpdateFnbReport.pending, (state, action) => {
        state.updatingId = action.meta.arg.id;
      })
      .addCase(asyncThunkUpdateFnbReport.fulfilled, (state, action) => {
        let report = state.yourReports.find(
          (item) => item.id === action.meta.arg.id
        );
        report.name = action.payload.data[0].name;
        report.terminal = action.payload.data[0].terminal;
        report.store = action.payload.data[0].store;
        report.breakup = action.payload.data[0].breakup;
        state.updatingId = null;
      })
      .addCase(asyncThunkUpdateFnbReport.rejected, (state, action) => {
        state.error = action.payload;
        state.updatingId = null;
      })
      .addCase(asyncThunkDeleteFnbReport.pending, (state, action) => {
        state.updatingId = action.meta.arg;
      })
      .addCase(asyncThunkDeleteFnbReport.fulfilled, (state, action) => {
        state.yourReports = state.yourReports.filter(
          (item) => item.id !== action.meta.arg
        );

        state.updatingId = null;
      })
      .addCase(asyncThunkDeleteFnbReport.rejected, (state, action) => {
        state.error = action.payload;
        state.updatingId = null;
      });
  },
});

export const { addReport, updateReport, removeReport } =
  yourReportsSlice.actions;

export default yourReportsSlice.reducer;
